document.addEventListener("DOMContentLoaded", () => {
    // Get section container
    let clinicalDataSection = document.querySelector('.clinical-data-js');
    if (!clinicalDataSection) return;

    // Get all buttons and info elements
    const infoButtons = clinicalDataSection.querySelectorAll('.tabs__button-container--button');
    const infoElements = clinicalDataSection.querySelectorAll('.tabs__info');
  
    if (infoButtons && infoElements) {
        // Add click event listeners to buttons
        infoButtons.forEach((button, index) => {
            button.addEventListener('click', () => {
                // Remove the 'active' class from all buttons and info elements
                infoButtons.forEach((btn) => {
                    btn.classList.remove('active');
                });
                infoElements.forEach((info) => {
                    info.classList.remove('active');
                });

                // Add the 'active' class to the clicked button and corresponding info element
                button.classList.add('active');
                infoElements[index].classList.add('active');
            });
        });

        // Activate the first button on load
        infoButtons[0].click();
    }


    // ***** LOGIC FOR DESCRIPTION BUTTONS ***** //
    let descriptionButtons = clinicalDataSection.querySelectorAll('.show-description-btn-js');
    let descriptionElements = clinicalDataSection.querySelectorAll('.item-description-js');

    if (descriptionButtons && descriptionElements) {
        descriptionButtons.forEach(btn => {
            btn.addEventListener('click', (e) => {
                e.preventDefault();
                if (btn.classList.contains('is-active')) {
                    btn.classList.remove('is-active');
                    descriptionElements.forEach(elem => {
                        if (elem.dataset.itemName === btn.dataset.itemName) {
                            elem.classList.remove('is-active');
                        }
                    });
                } else {
                    btn.classList.add('is-active');
                    descriptionElements.forEach(elem => {
                        if (elem.dataset.itemName === btn.dataset.itemName) {
                            elem.classList.add('is-active');
                        }
                    });
                }
            });
        });
    }
  
});